import React, {useMemo, useState} from "react";
import AdminNav from "../../nav/AdminNav";
import Users from "./panelPages/Users";
import SkillTypes from "./panelPages/SkillTypes";
import UserResumes from "./panelPages/UserResumes";
import UserEdit from "./panelPages/UserEdit";
import AdminSkills from "./panelPages/AdminSkills";
import AdminCerts from "./panelPages/AdminCerts";

const Admin = () => {
    const [active, setActive] = useState('users');

    const renderPage = useMemo(() => {
        switch (active) {
            case 'users':
                return <Users />;
            case 'skills':
                return <AdminSkills />;
            case 'skillTypes':
                return <SkillTypes />;
            case 'certs':
                return <AdminCerts />;
            case 'userResumes':
                return <UserResumes />;
            case 'userEdit':
                return <UserEdit />;
            default:
                break; //do nothing
        }
    }, [active]);

    return useMemo(() =>{
        return (
        <div className="main-content">
            <h2>Admin Panel</h2>
            <AdminNav appearance="tabs" active={active} onSelect={setActive} />
            {renderPage}
        </div>
        );
    }, [active, renderPage]);
};

export default Admin;